export default "__VITE_ASSET__CaAcBVxD__"